export default __webpack_public_path__ + "static/media/bg.8c9196a2.webp";